import { useState, useEffect, ReactNode } from "react";

import "./style.scss";
import LeftMenuLayout from "../layout/left-menu-layout.comp";
import GeneralMenu from "../admin/general-menu/general-menu.comp";
import { FirebaseAuthContainer } from "../../common/containers/auth/firebase-auth-container.util";
import { ThemeContainer } from "../../common/containers/theme/theme.container";
import { LoaderView } from "../loader/loader.comp";
import { GoogleOAuthProvider } from "@react-oauth/google";
import { googleDriveConfig } from "../../common/utilities/constants/constants";
import { subscribeForceUpdate } from "../../api/admin/knowledge-base/endpoints-referrers";

const GeneralMenuLayout = ({ children }: { children: ReactNode }) => {
    const { user, knowledgeBases, loadKnowledgeBases, refreshKnowledgeBase } =
        FirebaseAuthContainer.useContainer();
    const { devMode, leftMenuCollapsed, isLoadingLoader } = ThemeContainer.useContainer();
    const [assistantAvailable, setAssistantAvailable] = useState<boolean>(false);

    useEffect(() => {
        setAssistantAvailable(
            !!user?.currentKnowledgeBaseId &&
                knowledgeBases.find(kb => kb.uid === user.currentKnowledgeBaseId)?.status ===
                    "active"
        );
    }, [user, knowledgeBases]);

    // Subscribe to SSE to refresh knowledge bases when KB status changes
    useEffect(() => {
        if (!user) return;

        const eventSource = subscribeForceUpdate(user.companyId);

        eventSource.onmessage = ({ data }: { data: string }) => {
            try {
                const message = JSON.parse(data);
                if (message.type === "kb_status_change") {
                    loadKnowledgeBases(user.companyId);
                    refreshKnowledgeBase();
                }
            } catch {
                // ignore parse errors
            }
        };

        return () => {
            eventSource.close();
        };
        // Re-subscribe only when the user changes; loadKnowledgeBases /
        // refreshKnowledgeBase are context callbacks with an unstable identity,
        // so depending on them would re-open the EventSource every render.
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [user]);

    return (
        <LeftMenuLayout
            leftMenu={
                <GoogleOAuthProvider clientId={googleDriveConfig.clientId || ""}>
                    <GeneralMenu
                        collapsedType={leftMenuCollapsed}
                        assistantAvailable={assistantAvailable}
                        showForceSync={devMode}
                    />
                </GoogleOAuthProvider>
            }
        >
            {children}
            <LoaderView show={isLoadingLoader} />
        </LeftMenuLayout>
    );
};

export default GeneralMenuLayout;
